export const getStep = (state) => state.step.step; // so bad..
